export default "__VITE_ASSET__Lrj7dNr2__"